import { useState } from "react";
import { Link } from "react-router-dom";
import AdminAreaSwitcher from "../../shared/components/AdminAreaSwitcher";
import logo from "./assets/logo.png";
import useEntertainmentBrand from "./useEntertainmentBrand";
import "./entertainmentAdmin.css";

export default function EntertainmentAdminLayout({ children }) {
  useEntertainmentBrand();
  const [open, setOpen] = useState(false);
  return <div className={`entertainmentAdminLayout${open ? " navigationOpen" : ""}`}>
    <button type="button" className="entAdminMenuToggle" onClick={() => setOpen(value => !value)} aria-expanded={open} aria-controls="entertainment-admin-nav">☰ Menu</button>
    <aside id="entertainment-admin-nav" className="entAdminSidebar">
      <Link to="/avwakinentertainment/admin" className="entAdminBrand"><img src={logo} alt="Avwakin Entertainment" /><strong>Avwakin<span>Entertainment</span></strong></Link>
      <nav aria-label="Entertainment administration" onClick={() => setOpen(false)}><div className="entAdminNavGroup"><p>Content</p><Link to="/avwakinentertainment/admin/upload-video">Upload Video</Link></div><Link to="/avwakinentertainment/admin">Settings</Link></nav>
      <Link className="entAdminPublicLink" to="/avwakinentertainment">View public website ↗</Link>
    </aside>
    <section className="entAdminMain"><header className="entAdminTopbar"><div><p>Administration</p><h1>Avwakin Entertainment</h1></div><Link to="/avwakinentertainment">Public site ↗</Link></header><div className="entAdminContent"><AdminAreaSwitcher />{children}</div></section>
  </div>;
}
